import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputList from '../../input-list/InputList';
import convertToSuperscript from '../../../../functions/convertToSuperscript';
import convertToSubscript from '../../../../functions/convertToSubscript';
import './Prompts.css';

class ImagePrompt extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null
    };
  }
  
  handleSubmit = (receivedValues) => {
    if (!receivedValues.errors.length) {
      let imageUrl = (receivedValues.values[this.props.formId + "-image-url"]) ?
      receivedValues.values[this.props.formId + "-image-url"] :
      null;
      
      let imageAltText = (receivedValues.values[this.props.formId + "-image-alt-text"]) ?
        receivedValues.values[this.props.formId + "-image-alt-text"] :
        null;
      
      this.setState({ errorMessage: null });
      
      this.props.handleSubmit(imageUrl, imageAltText);
    }
    else {
      this.setState({ errorMessage: receivedValues.errors.join(", ") });
    }
  }
  
  handleCancel = () => {
    this.setState({ errorMessage: null });
    this.props.handleCancel();
  }
  
  render() {
    let inputListArray = [
      {
        label: 'Image URL',
        type: 'text',
        id: this.props.formId + '-image-url',
        patternMatch: /\.(jpeg|jpg|gif|png|ashx)/i,
        patternMatchError: 'Image URL Must Be One of These Formats: .ashx, .gif, .jpeg, .jpg, .png',
        required: true
      },
      {
        label: 'Alt Text',
        type: 'text',
        id: this.props.formId + '-image-alt-text'
      },
      {
        type: 'button',
        value: 'Cancel',
        className: 'prompt__button--cancel',
        onClick: this.handleCancel
      },
      {
        type: 'submit',
        value: 'Add Image',
        className: 'button button--small'
      }
    ];
    
    let errorMessage = (this.state.errorMessage) ?
      <div className="prompt__error-message">{this.state.errorMessage}</div> :
      null;

    let promptContent = (this.props.isShowing) ?
      <span className="prompt__content">
        <InputList
          formId={this.props.formId}
          inputs={inputListArray}
          onSubmit={(receivedValues) => this.handleSubmit(receivedValues)}
        />
        {errorMessage}
      </span> :
      null;

    return (
      <span className="image-prompt">
        {promptContent}
      </span>
    );
  }
}

ImagePrompt.propTypes = {
  formId: PropTypes.string.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isShowing: PropTypes.bool.isRequired
}


class LinkPrompt extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null
    };
  }
  
  handleSubmit = (receivedValues) => {
    if (!receivedValues.errors.length) {
      let linkText = (receivedValues.values[this.props.formId + "-link-text"]) ?
      receivedValues.values[this.props.formId + "-link-text"] :
      null;
    
      let linkUrl = (receivedValues.values[this.props.formId + "-link-url"]) ?
        receivedValues.values[this.props.formId + "-link-url"] :
        null;
      
      this.setState({ errorMessage: null });

      this.props.handleSubmit(linkUrl, linkText);
    }
    else {
      this.setState({ errorMessage: receivedValues.errors.join(", ") });
    }
  }
  
  handleCancel = () => {
    this.setState({ errorMessage: null });
    this.props.handleCancel();
  }
  
  render() {
    let inputListArray = [
      {
        label: 'URL',
        type: 'text',
        id: this.props.formId + '-link-url',
        patternMatch: /^(http:\/\/|https:\/\/|mailto:)/g,
        patternMatchError: 'Link must start with http://, https://, or mailto:',
        required: true
      },
      {
        type: 'button',
        value: 'Cancel',
        className: 'prompt__button--cancel',
        onClick: this.handleCancel
      },
      {
        type: 'submit',
        value: 'Add Link',
        className: 'button button--small'
      }
    ];
    
    if (this.props.promptForText) {
      inputListArray.unshift({
        label: 'Text',
        type: 'text',
        id: this.props.formId + '-link-text',
        required: true
      });
    }
    
    let errorMessage = (this.state.errorMessage) ?
      <div className="prompt__error-message">{this.state.errorMessage}</div> :
      null;

    let promptContent = (this.props.isShowing) ?
      <span className="prompt__content">
        <InputList
          formId={this.props.formId}
          inputs={inputListArray}
          onSubmit={(receivedValues) => this.handleSubmit(receivedValues)}
        />
        {errorMessage}
      </span> :
      null;

    return (
      <span className="link-prompt">
        {promptContent}
      </span>
    );
  }
}
    
LinkPrompt.defaultProps = {
  promptForText: false
}

LinkPrompt.propTypes = {
  formId: PropTypes.string.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isShowing: PropTypes.bool.isRequired,
  promptForText: PropTypes.bool
}


const CharactersPrompt = (props) => {
  const characters = [ "©", "®", "™", "𝙋",
    "≤", "≥", "±", "ά",
    "α", "Β", "Δ", "ӧ", 
    "ϋ", "—", "–" ];
  let inputListArray = [];
  
  inputListArray.push(characters.map((character) => {
    return {
      type: 'button',
      value: character,
      className: 'prompt__button--character',
      onClick: () => props.handleSubmit(character)
    }
  }));

  inputListArray.push([{
    type: 'button',
    value: 'Cancel',
    className: 'prompt__button--cancel',
    onClick: props.handleCancel
  }]);

  let promptContent = (props.isShowing) ?
    <span className="prompt__content">
      <InputList
        formId={props.formId}
        inputs={inputListArray}
      />
    </span> :
    null;

  return (
    <span className="characters-prompt">
      {promptContent}
    </span>
  );
}

CharactersPrompt.propTypes = {
  formId: PropTypes.string.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isShowing: PropTypes.bool.isRequired
}


class SupSubPrompt extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null
    };
  }
  
  handleSubmit = (receivedValues, type) => {
    if (type === "superscript") {
      if (!(receivedValues.values[this.props.formId + "-sup-sub-characters"].match(/^[A-PR-Za-pr-z0-9\-—– ]+$/g))) {
        receivedValues.errors.push("Characters must be letters (except q), numbers, and dashes");
      }
    }
    else {
      if (!(receivedValues.values[this.props.formId + "-sup-sub-characters"].match(/^[0-9\-—–+() ]+$/g))) {
        receivedValues.errors.push("Characters must be numbers, parentheses, and +/-");
      }
    }
    
    if (!receivedValues.errors.length) {
      let characters = (receivedValues.values[this.props.formId + "-sup-sub-characters"]) ?
      receivedValues.values[this.props.formId + "-sup-sub-characters"] :
      null;
      
      let scriptedCharacters = (type === "superscript") ? 
        convertToSuperscript(characters) : 
        convertToSubscript(characters);
      
      this.setState({ errorMessage: null });
      
      this.props.handleSubmit(scriptedCharacters);
    }
    else {
      this.setState({ errorMessage: receivedValues.errors.join(", ") });
    }
  }
  
  handleCancel = () => {
    this.setState({ errorMessage: null });
    this.props.handleCancel();
  }
  
  render() {
    let inputListArray = [
      {
        label: 'Characters',
        type: 'text',
        id: this.props.formId + '-sup-sub-characters',
        required: true
      },
      {
        type: 'button',
        value: 'Cancel',
        className: 'prompt__button--cancel',
        onClick: this.handleCancel
      },
      {
        type: 'button',
        name: 'superscript',
        value: 'Superscript',
        className: 'button button--small prompt__button--space',
        onClick: () => { 
          this.handleSubmit(
            this[this.props.formId].getValues(), 
            "superscript"
          ); 
        }
      },
      {
        type: 'button',
        name: 'subscript',
        value: 'Subscript',
        className: 'button button--small',
        onClick: () => { 
          this.handleSubmit(
            this[this.props.formId].getValues(), 
            "subscript"
          ); 
        }
      }
    ];
    
    let errorMessage = (this.state.errorMessage) ?
      <div className="prompt__error-message">{this.state.errorMessage}</div> :
      null;

    let promptContent = (this.props.isShowing) ?
      <span className="prompt__content">
        <InputList
          formId={this.props.formId}
          inputs={inputListArray}
          ref={instance => { this[this.props.formId] = instance; }}
        />
        {errorMessage}
      </span> :
      null;

    return (
      <span className="sup-sub-prompt">
        {promptContent}
      </span>
    );
  }
}

SupSubPrompt.propTypes = {
  formId: PropTypes.string.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isShowing: PropTypes.bool.isRequired
}

export { 
  ImagePrompt, 
  LinkPrompt, 
  CharactersPrompt,
  SupSubPrompt
}



// WEBPACK FOOTER //
// ./src/shared/components/presentation/rich-text-editor/prompts/Prompts.js